import { createRouter, createWebHistory } from 'vue-router';
import { useIdentityStore } from '@/stores/useIdentityStore';
import Home from '@/views/home/home.vue';
import applyList from '@/views/home/ApplyList.vue';
import SignIn from '@/views/identity/sign.in.vue';
import news from '@/views/page/news.vue';
import newsview from '@/views/page/newsview.vue';
import DynamicHtmlPage from '../components/DynamicHtmlPage.vue';
import index from '@/views/page/default.vue'; 
import apply from '@/views/page/apply.vue'; 
import newsCategory from '@/views/home/newsCategory.vue'; 
import NewsDataAnalytics from '@/views/page/NewsDataAnalytics.vue'; 
import baseConfig from '@/views/home/baseConfig.vue';

const routes = [
  {
    path: '/',
    redirect: { name: 'index' }
  },
  {
    path: '/index',
    name: 'index',
    meta: { allowAnonymous: true }, 
    component: index,
  }, 
  {
    path: '/home',
    name: 'Home',
    meta: { allowAnonymous: false ,title:'新闻管理'},
    component: Home,
  },
  {
    path:'/baseConfig',
    name: 'baseConfig',
    meta: { allowAnonymous: false ,title:'配置管理'},
    component: baseConfig,
  },
  {
    path: '/applyList',
    name: 'applyList',
    meta: { allowAnonymous: false ,title:'在线申请管理'},
    component: applyList,
  },
  {
    path: '/news',
    name: 'news',
    meta: { allowAnonymous: true,title:'新闻动态' },
    component: news,

  },
  {
    path: '/newsCategory',
    name: 'newsCategory',
    meta: { allowAnonymous: false,title:'新闻分类管理' },
    component: newsCategory,
  },
  { 
    path: '/newsview',
    name: 'newsview',
    meta: { allowAnonymous: true,title:'新闻详情' },
    component: newsview,

  }, 
  { 
    path: '/NewsDataAnalytics',
    name: 'NewsDataAnalytics',
    meta: { allowAnonymous: true,title:'新闻数据分析' },
    component: NewsDataAnalytics,

  }, 
  { 
    path: '/apply',
    name: 'apply',
    meta: { allowAnonymous: true,title:'在线申请' },
    component: apply,

  }, 
  
  {
    path: '/signin',
    name: 'Signin',
    meta: { allowAnonymous: true,title:'后台登录' },
    component: SignIn,
  }, 
    // 添加通配符路由匹配
  {
    path: '/:pathMatch(.*)*', // 通配符路径，匹配所有未定义路径
    redirect: { name: 'index' } // 重定向到 index 页面
  }
];
 
const router = new createRouter({
  history: createWebHistory(), // 可以根据需求选择不同的路由模式，这里使用历史模式
  routes
}); 

router.beforeEach((to) => {
  if (to.path === '/') {
    // 如果是根路径，重定向到默认页
    //next('/index');
    return {name:'index',replace:true};
  }
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.meta.allowAnonymous) {
    return true;
  }
  
  if (!localStorage.getItem('accessToken')) {
    return {
      name: 'Signin',
      query: { redirect: to.fullPath }, // 在 query 中记录目标路径
      replace: true,
    };
  }

});


export default router;
